export class DocumentSearchParameter {
  patientId: string;
  fromDate: string;
  toDate: string;
  durationName: string;
  departmentGroupId: string;
  departmentIds: string[];
  departmentId: string;
  containsDeleted: boolean;
  containsTemporary: boolean;
  containsRegistered: boolean;
  documentKindIds: string[];
  loginUserId: string;
  contentDateSearch: boolean;
  loginUserOnly: boolean;
  formatName: string;
  // formatIdsは「,」区切りの文字列になってるが本来配列で持つべき.他のアプリからも利用されてるので修正は見送り.真似しない事.
  formatIds: string;
  manageNumberText: string;
  containsVirtualDocuments: boolean;
  updateUserCodes: string[];
 
  constructor() {
    this.patientId = "";
    this.fromDate = "";
    this.toDate = "";
    this.durationName = "";
    this.departmentGroupId = "";
    this.departmentIds = [""];
    this.departmentId = "";
    this.containsDeleted = false;
    this.containsTemporary = false;
    this.containsRegistered = false;
    this.documentKindIds = [];
    this.loginUserId = "";
    this.contentDateSearch = false;
    this.loginUserOnly = false;
    this.formatName = "";
    this.formatIds = "";
    this.manageNumberText = "";
    this.containsVirtualDocuments = false;
    this.updateUserCodes = [];
  }
 
  clone(): DocumentSearchParameter {
    const parameter = new DocumentSearchParameter();
    parameter.patientId = this.patientId;
    parameter.fromDate = this.fromDate;
    parameter.toDate = this.toDate;
    parameter.durationName = this.durationName;
    parameter.departmentGroupId = this.departmentGroupId;
    parameter.departmentIds = this.departmentIds;
    parameter.departmentId = this.departmentId;
    parameter.containsDeleted = this.containsDeleted;
    parameter.containsTemporary = this.containsTemporary;
    parameter.containsRegistered = this.containsRegistered;
    parameter.documentKindIds = this.documentKindIds;
    parameter.loginUserId = this.loginUserId;
    parameter.contentDateSearch = this.contentDateSearch;
    parameter.loginUserOnly = this.loginUserOnly;
    parameter.formatName = this.formatName;
    parameter.formatIds = this.formatIds;
    parameter.manageNumberText = this.manageNumberText;
    parameter.containsVirtualDocuments = this.containsVirtualDocuments;
    parameter.updateUserCodes = this.updateUserCodes;
    return parameter;
  }
}
